import { render, staticRenderFns } from "./upFile.vue?vue&type=template&id=20730ac6&scoped=true"
import script from "./upFile.vue?vue&type=script&lang=js"
export * from "./upFile.vue?vue&type=script&lang=js"
import style0 from "./upFile.vue?vue&type=style&index=0&id=20730ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20730ac6",
  null
  
)

export default component.exports